import React from "react";
import ModalImage from "react-modal-image";
import TokenImage from "./TokenImage";

export default function TokenModalImage(props) {
  const { small, large, ...imgProps } = props;
  return (
    <TokenImage
      src={[small, large]}
      render={(src) => (
        <ModalImage
          small={src ? src[0] : undefined}
          large={src ? src[1] : undefined}
          {...imgProps}
        />
      )}
    />
  );
}
